import React from 'react';
import styles from './MockAd.module.css';

const MockAd = ({ placement = 'banner', style = {}, position = 'left' }) => {
  const mockAds = {
    banner: {
      title: "Home Depot - Kitchen Renovation Sale",
      description: "Save up to 40% on kitchen cabinets, countertops & appliances. Free installation estimates.",
      cta: "Shop Now",
      image: "🏠",
      color: "#ff6b35"
    },
    inline: {
      title: "Lowe's Professional Installation",
      description: "Bathroom remodel? Get professional installation from trusted contractors in your area.",
      cta: "Get Quote",
      image: "🔨",
      color: "#004990"
    },
    footer: {
      title: "Local Contractor Network",
      description: "Connect with top-rated contractors • Licensed & Insured • Free Estimates",
      cta: "Find Contractors",
      image: "⚡",
      color: "#28a745"
    },
    sidebar: {
      left: {
        title: "Quality Tools & Materials",
        description: "Professional grade tools and materials for your home improvement projects. Free delivery on orders over $50. Trusted by contractors nationwide.",
        cta: "Shop Tools",
        image: "🛠️",
        color: "#6f42c1",
        features: ["✓ Free Delivery", "✓ Pro Grade Quality", "✓ 30-Day Returns", "✓ Expert Support"]
      },
      right: {
        title: "Licensed Contractors",
        description: "Find pre-screened, licensed contractors in your area. Get multiple quotes instantly. All contractors are background checked and insured.",
        cta: "Find Pros",
        image: "👷",
        color: "#e83e8c",
        features: ["✓ Background Checked", "✓ Licensed & Insured", "✓ Multiple Quotes", "✓ Local Experts"]
      }
    }
  };

  // Get ad data based on placement and position
  let adData;
  if (placement === 'sidebar') {
    adData = mockAds.sidebar[position] || mockAds.sidebar.left;
  } else {
    adData = mockAds[placement] || mockAds.banner;
  }

  // Don't show if user has premium subscription (for testing)
  const hasActiveSubscription = localStorage.getItem('hasActiveSubscription') === 'true';
  
  // For testing, let's show ads anyway, but add a "TEST MODE" indicator
  const isTestMode = true; // You can toggle this

  if (hasActiveSubscription && !isTestMode) {
    return null;
  }

  return (
    <div className={`${styles.mockAd} ${styles[placement]}`} style={style}>
      {isTestMode && (
        <div className={styles.testBadge}>TEST AD</div>
      )}
      <div className={styles.adLabel}>Advertisement</div>
      <div className={styles.adContent}>
        <div className={styles.adIcon} style={{ backgroundColor: adData.color }}>
          {adData.image}
        </div>
        <div className={styles.adText}>
          <h4 className={styles.adTitle}>{adData.title}</h4>
          <p className={styles.adDescription}>{adData.description}</p>
          {adData.features && placement === 'sidebar' && (
            <div className={styles.adFeatures}>
              {adData.features.map((feature, index) => (
                <div key={index} className={styles.adFeature}>
                  {feature}
                </div>
              ))}
            </div>
          )}
        </div>
        <button className={styles.adCta} style={{ backgroundColor: adData.color }}>
          {adData.cta}
        </button>
      </div>
    </div>
  );
};

export default MockAd; 